import React from "react"
import { StaticImage } from 'gatsby-plugin-image'

export const SocialMediaLinks = () => {
  return (
    <ul>
      <li className="inline-block text-[29px] leading-[29px] mr-5">
        <a href="https://www.instagram.com/joinparachute/" target="_blank">
          <StaticImage
            alt="Instagram"
            src="../../../images/social-media/social-logo-instagram.png"
          />
        </a>
      </li>
      <li className="inline-block text-[29px] leading-[29px] mr-5">
        <a href="https://twitter.com/joinparachute" target="_blank">𝕏</a>
      </li>
      <li className="inline-block text-[29px] leading-[29px] mr-5">
        <a href="https://www.facebook.com/Join-Parachute-103668707964239" target="_blank">
          <StaticImage
            alt="Facebook"
            src="../../../images/social-media/social-logo-facebook.png"
          />
        </a>
      </li>
    </ul>
  )
}
